import { ChangeDetectionStrategy, Component, ContentChild, Input, input, output, TemplateRef } from '@angular/core';
import { NzPopoverDirective } from 'ng-zorro-antd/popover';
import { PopoverPlacement } from './popover.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzPopoverDirective],
  selector: 'ui-popover',
  template: `
    <div
      nz-popover
      [nzPopoverVisible]="visible()"
      nzPopoverTrigger="click"
      [nzPopoverPlacement]="placement() || 'bottom'"
      [nzPopoverContent]="popoverTemplate"
      (nzPopoverVisibleChange)="emitPopoverVisibleChange($event)"
      class="w-fit"
    >
      <ng-content></ng-content>
    </div>

    <ng-template #popoverTemplate>
      <ng-content select="[popover-content]"></ng-content>
    </ng-template>
  `,
  styles: [`
    ::ng-deep .ant-popover-inner {
      border-radius: 8px;
    }
  `]
})

export class PopoverComponent {
  placement = input<PopoverPlacement>();
  visible = input<boolean>(false);
  popoverVisibleChange = output<boolean>();

  @ContentChild('popoverContent', { static: false }) popoverContent: TemplateRef<any> | undefined;
  popoverTemplate: TemplateRef<any> | undefined;

  ngAfterContentInit(): void {
    if (this.popoverContent) {
      this.popoverTemplate = this.popoverContent;
    }
  }

  emitPopoverVisibleChange(visible: boolean) {
    this.popoverVisibleChange.emit(visible)
  }
}
